import * as React from "react";
const WidgetDetailsContext = React.createContext({
  parameters: {},
  searchIds: {},
  widgets: {},
  isLoading: false
});
export default WidgetDetailsContext;
